// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Info__container-b7bf01 {
  display: flex;
  flex-direction: column;
  margin: 16px 0 8px 0;
}

.Info__count-febc7d {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.Info__statuses-bdbb5f {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}

.Info__participants-b5ab53 {
  display: flex;
  flex-direction: column;
}

.Info__participant-e054b7 {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
  padding: 8px 0;
}

.Info__title-b66a30 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  margin-inline-start: 24px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Info__initiator-c161bd {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.Info__container-status-icon-ff1397 {
  width: 22px;
  height: 22px;
  background-color: var(--base-0);
  position: absolute;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Info__background-status-icon-eecf52 {
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Info__background-color-maybe-b4e61c,
.Info__background-color-awaiting-d20058 {
  background-color: var(--base-30);
}

.Info__background-color-accepted-cb9f8d {
  background-color: var(--success-40);
}

.Info__background-color-declined-c52073 {
  background-color: var(--danger-40);
}

.Info__color-maybe-e256cc,
.Info__color-awaiting-cdb6cc {
  fill: var(--base-70);
}

.Info__color-accepted-ed01ec path,
.Info__color-declined-b19fa5 path {
  fill: var(--addition-50);
}

.Info__icon-ed8d3a {
  height: 16px;
  width: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Info/Participants.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,gCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;;EAEE,oBAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  margin: 16px 0 8px 0;\n}\n\n.count {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.statuses {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n\n.participants {\n  display: flex;\n  flex-direction: column;\n}\n\n.participant {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  overflow: hidden;\n  padding: 8px 0;\n}\n\n.title {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  margin-inline-start: 24px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.initiator {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.container-status-icon {\n  width: 22px;\n  height: 22px;\n  background-color: var(--base-0);\n  position: absolute;\n  right: -6px;\n  bottom: -6px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.background-status-icon {\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.background-color-maybe,\n.background-color-awaiting {\n  background-color: var(--base-30);\n}\n\n.background-color-accepted {\n  background-color: var(--success-40);\n}\n\n.background-color-declined {\n  background-color: var(--danger-40);\n}\n\n.color-maybe,\n.color-awaiting {\n  fill: var(--base-70);\n}\n\n.color-accepted path,\n.color-declined path {\n  fill: var(--addition-50);\n}\n\n.icon {\n  height: 16px;\n  width: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Info__container-b7bf01`,
	"count": `Info__count-febc7d`,
	"statuses": `Info__statuses-bdbb5f`,
	"participants": `Info__participants-b5ab53`,
	"participant": `Info__participant-e054b7`,
	"title": `Info__title-b66a30`,
	"initiator": `Info__initiator-c161bd`,
	"container-status-icon": `Info__container-status-icon-ff1397`,
	"containerStatusIcon": `Info__container-status-icon-ff1397`,
	"background-status-icon": `Info__background-status-icon-eecf52`,
	"backgroundStatusIcon": `Info__background-status-icon-eecf52`,
	"background-color-maybe": `Info__background-color-maybe-b4e61c`,
	"backgroundColorMaybe": `Info__background-color-maybe-b4e61c`,
	"background-color-awaiting": `Info__background-color-awaiting-d20058`,
	"backgroundColorAwaiting": `Info__background-color-awaiting-d20058`,
	"background-color-accepted": `Info__background-color-accepted-cb9f8d`,
	"backgroundColorAccepted": `Info__background-color-accepted-cb9f8d`,
	"background-color-declined": `Info__background-color-declined-c52073`,
	"backgroundColorDeclined": `Info__background-color-declined-c52073`,
	"color-maybe": `Info__color-maybe-e256cc`,
	"colorMaybe": `Info__color-maybe-e256cc`,
	"color-awaiting": `Info__color-awaiting-cdb6cc`,
	"colorAwaiting": `Info__color-awaiting-cdb6cc`,
	"color-accepted": `Info__color-accepted-ed01ec`,
	"colorAccepted": `Info__color-accepted-ed01ec`,
	"color-declined": `Info__color-declined-b19fa5`,
	"colorDeclined": `Info__color-declined-b19fa5`,
	"icon": `Info__icon-ed8d3a`
};
module.exports = ___CSS_LOADER_EXPORT___;
